/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtract_One_FrameInputs */



/**
* | output |
* | --- |
* | "1 Frame" |
*
* @param {Subtract_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtract_one_frame = /** @type {((inputs?: Subtract_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtract_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("1 image")
	if (locale === "de") return /** @type {LocalizedString} */ ("1 Rahmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("1 fotogramma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("1 кадр")
	if (locale === "es") return /** @type {LocalizedString} */ ("1 fotograma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("1帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1フレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1 फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("1 Quadro")
	return /** @type {LocalizedString} */ ("1 Frame")
});